import * as userService from './service/user.service';

const state = {
	user: null,
	responsibles: [],
};

const mutations = {
	SET_USER(state, payload) {
		state.tool = payload;
	},
	SET_RESPONSIBLES(state, payload) {
		state.responsibles = payload
	}
};

const actions = {
	async updatePassword(context, payload) {
		try {
			const response = await userService.updatePassword(payload);
			return { ok: true, response };
		} catch (error) {
			return { ok: false, error: error?.response };
		}
	},

	async getResponsibles({ commit }, data) {
		try {
			const response = await userService.getResponsibles(data);
			commit('SET_RESPONSIBLES', response || []);
			return { ok: true, response }
		} catch (error) {
			return { ok: false, error: error?.response || 'Error en el servicio' }
		}
	}
};

const getters = {
	getHeaderById: (state) => (id) => {
		return { ...state.user, id };
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
